export const HOME = '/:app/'
export const LOGIN = '/:app/login'
export const TERM = '/:app/term'
export const PRIVACY = '/:app/privacy'
export const SEARCH = '/:app/search'
export const PDF_VIEW = '/:app/view'
export const HISTORY = '/:app/history'
export const BOOKMARK = '/:app/bookmark'
export const HELP = '/:app/help'
export const MAINTENANCE = '/maintenance'
